import { useRender } from '@base-ui/react/use-render'
import { cn } from '../../lib/cn'
import s from './IconButton.module.css'

/**
 * Bouton carré à icône seule — le « retour » des en-têtes du prototype.
 *
 * L'icône ne porte aucun texte : `label` est donc **obligatoire**, c'est le nom
 * accessible du bouton.
 *
 * La prop `render` (idiome Base UI, via `useRender`) permet d'habiller un autre
 * élément — typiquement le `Link` du routeur de l'app :
 *
 * ```tsx
 * <IconButton label="Retour" render={<Link to="/inspections" />}>
 *   <ArrowLeft aria-hidden />
 * </IconButton>
 * ```
 */
export interface IconButtonProps extends useRender.ComponentProps<'button'> {
  /** Nom accessible du bouton — l'icône n'en fournit aucun. */
  label: string
}

export function IconButton({ label, render, className, ...props }: IconButtonProps) {
  return useRender({
    render,
    defaultTagName: 'button',
    props: {
      'aria-label': label,
      className: cn(s.root, className),
      // Même défaut que `Button` : hors d'un `render`, jamais `submit` implicite.
      ...(render === undefined && { type: 'button' }),
      ...props,
    },
  })
}
